import { useState } from 'react';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';

const DatePicker = ({ nameInput, valDateInput, placeholderInput = "Дата", onDateChange }) => {
    const parseDate = (dateString) => {
        const [day, month, year] = dateString.split('.').map(Number);
        return new Date(year, month - 1, day); // Месяцы в JavaScript начинаются с 0
    };

    const [isOpen, setIsOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(valDateInput ? parseDate(valDateInput) : new Date());
    const [currentMonth, setCurrentMonth] = useState(new Date());

    const months = [
        'Янвать', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
    ];

    const prevMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
    };

    const nextMonth = () => {
        setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
    };

    const selectDate = (day) => {
        let valDateInput = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
        onDateChange && onDateChange(nameInput, format(valDateInput, 'dd.MM.yyyy'));
        setSelectedDate(valDateInput);
        setIsOpen(false);
    };

    const renderDays = () => {
        const firstDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1).getDay();
        const daysInMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0).getDate();
        const today = new Date().getDate();
        return (
            <>
                {Array.from({ length: firstDay - 1 }, (_, i) => (
                    <div key={`empty-${i}`} className="w-10 h-10"></div>
                ))}
                {Array.from({ length: daysInMonth }, (_, day) => {
                    const isSelected = selectedDate.getDate() === day + 1 && selectedDate.getMonth() === currentMonth.getMonth() && selectedDate.getFullYear() === currentMonth.getFullYear();
                    return (
                        <div
                            key={day + 1}
                            className={["w-8 h-8 flex items-center justify-center rounded-md cursor-pointer transition-all duration-200",
                                (day + 1 === today) && !isSelected ? "bg-gray-100 dark:bg-gray-800" : "",
                                isSelected ? "bg-green-500 text-white" : "text-gray-800 hover:bg-gray-200 dark:text-gray-200 dark:hover:bg-gray-700"
                            ].join(" ")}
                            onClick={() => selectDate(day + 1)}
                        >
                            {day + 1}
                        </div>
                    );
                })}
            </>
        );
    };

    return (
        <div className="relative transition-all duration-300 bg-transparent rounded-md">
            <input
                name={nameInput}
                type="text"
                value={format(selectedDate, "EEE dd MMM yyyy", { locale: ru })}
                // onChange={onChangeLocal}
                onClick={() => setIsOpen(!isOpen)}
                readOnly
                className="peer w-full px-4 py-2 bg-transparent rounded-md focus:outline-none ring-1 ring-gray-300 dark:ring-gray-600 focus:ring-green-400 transition-all duration-200 text-gray-800 dark:text-gray-200 placeholder-transparent"
            />
            <label htmlFor={nameInput} className="absolute bg-white dark:bg-gray-800 rounded-t-lg  cursor-pointer left-0 -top-3 text-sm text-gray-500 mx-1 px-1 peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-500 peer-placeholder-shown:top-2 peer-focus:-top-4 peer-focus:text-green-600 peer-focus:text-sm transition-all duration-300 pointer-events-none">{placeholderInput}</label>
            {isOpen && (
                <div className="absolute z-10 mt-1 right-0 w-64 bg-white dark:bg-gray-900  border border-gray-200 dark:border-gray-600 rounded-md shadow-lg p-4">
                    <div className="flex justify-between items-center mb-4">
                        <button onClick={prevMonth} className="text-green-500 hover:text-green-600 transition-all duration-200">&lt;</button>
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">{months[currentMonth.getMonth()]} {currentMonth.getFullYear()}</h3>
                        <button onClick={nextMonth} className="text-green-500 hover:text-green-600 transition-all duration-200">&gt;</button>
                    </div>
                    <div className="grid grid-cols-7 gap-2">
                        {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map(day => (
                            <div key={day} className="text-center font-medium text-gray-500 dark:text-gray-400">{day}</div>
                        ))}
                        {renderDays()}
                    </div>
                </div>
            )}
        </div>
    );
};

export default DatePicker;